module.exports = __webpack_public_path__ + "static/img/bg_drak.7a8f006.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_drak.png
// module id = tzdb
// module chunks = 1